module.exports = [
    {
        type: Object,
        isHeader: false,
        icon: 'fa el-icon-edit',
        name_th: 'จัดการ',
        items: [{
            name: ['ListOperator', 'Add_ListOperator', 'Edit_ListOperator'],
            name_th: 'จัดการรายชื่อบริษัทของผู้ให้บริการ',
            icon: 'fa el-icon-s-cooperation',
            router: { name: '/Admin/ListOperator' },
            link: '/Admin/ListOperator'
        }, {
            name: ['Upload_save'],
            name_th: 'นำส่งข้อมูลรายการส่งเสริมการขายเพื่อการกำกับดูแล',
            icon: 'fa el-icon-document-checked',
            router: { name: '/Admin/Upload_save' },
            link: '/Admin/Upload_save'
        }, {
            name: ['Manage_internet', 'Add_promotion_internet', 'Add_file_promotion_internet'],
            name_th: 'จัดการข้อมูลรายการส่งเสริมการขายอินเทอร์เน็ตความเร็วสูงประจำที่',
            icon: 'fa el-icon-monitor',
            router: { name: '/Admin/Manage_internet' },
            link: '/Admin/Manage_internet'
        }, {
            name: ['Manage_request_internet'],
            name_th: 'จัดการคำร้องของผู้ให้บริการอินเทอร์เน็ตประจำที่',
            icon: 'fa el-icon-message',
            router: { name: '/Admin/Manage_request_internet' },
            link: '/Admin/Manage_request_internet'
        }]
    }, {
        type: Object,
        isHeader: false,
        icon: 'fa fa-bar-chart-o',
        name_th: 'รายงาน',
        items: [{
            name: ['Fast_internet_home_G9'],
            name_th: 'รายงานรายการส่งเสริมการขายบริการอินเทอร์เน็ตความเร็วสูงประจำที่ในรูปแบบเทคโนโลยีต่างๆ',
            icon: 'fa fa-building-o',
            router: { name: '/Admin/Fast_internet_home_G9' },
            link: '/Admin/Fast_internet_home_G9'
        }, {
            name: ['Services_internet'],
            name_th: 'รายงานจำนวนรายการส่งเสริมการขายบริการอินเทอร์เน็ตความเร็วสูงประจำที่ในรูปแบบเทคโนโลยีต่างๆ ของแต่ละผู้ให้บริการ',
            icon: 'fa fa-bar-chart-o',
            router: { name: '/Admin/Services_internet' },
            link: '/Admin/Services_internet'
        }, {
            name: ['Fast_internet_home_G11'],
            name_th: 'รายงานอัตราค่าบริการอินเทอร์เน็ตความเร็วสูงประจำที่',
            icon: 'fa el-icon-s-marketing',
            router: { name: '/Admin/Fast_internet_home_G11' },
            link: '/Admin/Fast_internet_home_G11'
        }, {
            name: ['Fast_internet_home_G12'],
            name_th: 'รายงานอัตราค่าบริการเฉลี่ยของบริการอินเทอร์เน็ตความเร็วสูงประจำที่',
            icon: 'fa el-icon-s-marketing',
            router: { name: '/Admin/Fast_internet_home_G12' },
            link: '/Admin/Fast_internet_home_G12'
        }, {
            name: ['Reportview_promotion'],
            name_th: 'รายงานจำนวนผู้เข้าชมข้อมูลรายการส่งเสริมการขายจำแนกตามการให้บริการ',
            icon: 'fa fa-building-o',
            router: { name: '/Admin/Reportview_promotion' },
            link: '/Admin/Reportview_promotion'
        }, {
            name: ['Manage_data'],
            name_th: 'จัดเก็บข้อมูลจากเว็บไซต์ผู้ให้บริการ',
            icon: 'fa el-icon-s-platform',
            router: { name: '/Admin/Manage_data' },
            link: '/Admin/Manage_data'
        }, {
            name: ['Report_blockchain', 'Report_blockchainDetail'],
            name_th: 'รายงานแสดงการรับ-ส่งข้อมูลในบล็อกเชน (BlockChain)',
            icon: 'fa fa-building-o',
            router: { name: '/Admin/Report_blockchain' },
            link: '/Admin/Report_blockchain'
        }, {
            name: ['Popular_proInternet'],
            name_th: 'โปรโมชันเด่นของบริการอินเทอร์เน็ตประจำที่',
            icon: 'fa fa-building-o',
            router: { name: '/Admin/Popular_proInternet' },
            link: '/Admin/Popular_proInternet'
        }, {
            name: ['Report_promotion_ranking'],
            name_th: 'รายงานจัดอันดับรายการส่งเสริมการขาย',
            icon: 'fa fa-bar-chart-o',
            router: { name: '/Admin/Report_promotion_ranking' },
            link: '/Admin/Report_promotion_ranking'
        }, {
            name: ['User_behavior'],
            name_th: 'รายงานพฤติกรรมการค้นหาของผู้ใช้บริการ',
            icon: 'fa fa-bar-chart-o',
            router: { name: '/Admin/User_behavior' },
            link: '/Admin/User_behavior'
        }]
    }
]